import { DatabaseBlockDataSource } from '@blocksuite/hive/blocks/database';
import type { ExtensionType } from '@blocksuite/hive/store';

import { propertiesPresets } from '../database-block/properties';

export function patchDatabaseBlockConfigService(): ExtensionType {
  //TODO use service
  DatabaseBlockDataSource.externalProperties.value = propertiesPresets;
  return {
    setup: () => {},
  };
}
